import { Link } from "react-router-dom";
import { useSettings } from "@/contexts/SettingsContext";

const DEFAULT_LOGO_URL = "/api/files/creativecodez/uploads/ca6e44b1-8c67-4695-9967-b582c762baca.png";

export const BrandLogo = ({ testId = "brand-logo-link", hideTextOnMobile = false, onClick }) => {
  const settings = useSettings();
  const logoUrl = settings.logo_url || DEFAULT_LOGO_URL;
  const brandName = settings.brand_name || "Creative Codez";
  const words = brandName.trim().split(" ");
  const accentWord = words.pop();
  const leadingWords = words.join(" ");

  return (
    <Link to="/" data-testid={testId} onClick={onClick} className="flex items-center gap-3 group">
      <span className="flex items-center justify-center w-11 h-11 shrink-0">
        <img src={logoUrl} alt={brandName} className="w-11 h-11 object-contain" />
      </span>
      <span className={`font-display text-lg tracking-tight text-slate-900 dark:text-white whitespace-nowrap ${hideTextOnMobile ? "hidden sm:block" : ""}`}>
        {leadingWords && `${leadingWords} `}
        <span className="bg-gradient-to-r from-sky-400 via-teal-300 to-emerald-400 bg-clip-text text-transparent">{accentWord}</span>
      </span>
    </Link>
  );
};
